import { Attachment } from '@datum-group/isogd-openapi/lib';
import { useEffect, useState } from 'react';
import { services } from '@project/API';
import { AxiosResponse } from 'axios';
import {
  PhotoCarousel,
  PhotoCarouselItem,
} from '@project/components/PhotoCarousel';
import EMPTY_IMAGE from '@assets/images/empty-image.svg';

export interface AttachmentsCarouselProps {
  attachments: Attachment[];
  recordId: number | string;
  tableName: string;
}

export const AttachmentsCarousel = ({
  attachments,
  recordId,
  tableName,
}: AttachmentsCarouselProps) => {
  const [photos, setPhotos] = useState<PhotoCarouselItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAttachments = async (attachmentIds: number[]) => {
      setLoading(true);

      const promises = await Promise.allSettled<AxiosResponse>(
        attachmentIds.map((id: number) =>
          services.attachment.apiAttachmentPagesRead(
            '0',
            '' + recordId,
            '' + id,
            tableName,
            { responseType: 'blob' },
          ),
        ),
      );

      const urls: string[] = [];

      promises.forEach((promise) => {
        if (promise.status === 'fulfilled' && 'value' in promise) {
          const url = window.URL.createObjectURL(promise.value.data);
          urls.push(url);
        } else if (promise.status === 'rejected') {
          urls.push(EMPTY_IMAGE);
        }
      });

      setPhotos(urls.map((photo) => ({ photo })));
      setLoading(false);
    };

    fetchAttachments(attachments.filter((a) => a.id).map((a) => a.id!));
  }, [attachments, recordId, tableName]);

  useEffect(() => {
    return () => {
      photos.forEach((item) => {
        if (item.photo.startsWith('blob:')) {
          window.URL.revokeObjectURL(item.photo);
        }
      });
    };
  }, [photos]);

  return loading || photos.length > 0 ? (
    <PhotoCarousel
      loading={loading}
      items={photos}
      style={{ width: 380, height: 270 }}
    />
  ) : null;
};

export default AttachmentsCarousel;
